import { createSlice } from "@reduxjs/toolkit";

export interface OutageResult {
    outageId: number,
    site: string,
    status: string,
    product: string,
    volume: number,
    outageDate: Date,
    deliveryDate: Date,
    notes: string,
    closingNotes: string,
    outageReason: string,
    createdDate: Date,
    updatedDate: Date,
    reportingSource: string,
    carrierName: string,
    totalRecords: number
}

export interface OutageState {
    data: OutageResult[] | null
}

const initialState: OutageState = {
    data: null
}

const OutageSlice = createSlice({
    name: 'Outage',
    initialState,
    reducers: {
        setOutageResults(state: OutageState, action: any) {
            state.data?.splice(0);

            if (action.payload.data.length > 0) {
                state.data = [];
                action.payload.data.map((obj: OutageResult) => {
                    if (state.data != null) {
                        state.data.push(obj);
                    }
                });
            }
        },
        clearResultData(state: OutageState, action: any) {
            state.data?.splice(0);
        }
    }
});

export const OutageActions = OutageSlice.actions;

export default OutageSlice;